import {
  ClockIcon,
  ClipboardDocumentListIcon,
  ChartBarIcon,
  CalendarDaysIcon,
  BanknotesIcon,
  UsersIcon,
  WrenchScrewdriverIcon,
  TruckIcon
} from '@heroicons/react/24/outline'

/**
 * Module keys that have been renamed: old -> new. A saved sidebar order can
 * still contain an old key (see TenantContext).
 */
export const RENAMED_MODULE_KEYS = { truck_check: 'apparatus' }

const moduleConfig = {
  time_tracker: {
    name: 'Time Tracker',
    Icon: ClockIcon,
    path: '/time'
  },
  incident_reports: {
    name: 'Incident Reports',
    Icon: ClipboardDocumentListIcon,
    path: '/reports'
  },
  apparatus: {
    name: 'Apparatus',
    Icon: TruckIcon,
    path: '/apparatus'
  },
  analytics: {
    name: 'Analytics',
    Icon: ChartBarIcon,
    path: '/analytics'
  },
  calendar: {
    name: 'Calendar',
    Icon: CalendarDaysIcon,
    path: '/calendar'
  },
  billing: {
    name: 'Billing',
    Icon: BanknotesIcon,
    path: '/billing'
  },
  personnel: {
    name: 'Personnel',
    Icon: UsersIcon,
    path: '/personnel'
  },
  // Equipment, not 'Gear & Equipment'. It holds turnout gear, saws, thermal
  // cameras and hose lengths -- anything the department tracks as an
  // individual asset with a service history.
  //
  // There were 'inventory' and 'training' entries above this, both pointing at
  // paths with no route. Enabling either put a link to a 404 in the sidebar.
  gear: {
    name: 'Equipment',
    Icon: WrenchScrewdriverIcon,
    path: '/equipment'
  }
}

export default moduleConfig
